import React, { useState } from 'react';
import Titlebar from './Titlebar';

function StationAddForm() {
  const [formData, setFormData] = useState({
    name: '',
    call: '',
    band: 'FM',
    frequency: '',
    city: '',
    state: '',
    country: 'US',
    website: '',
    logo_url: '',
    description: '',
    stream_provider: '',
    stream_acquisition_url: '',
    stream_url: '',
    parent_company: '',
    parent_company_website: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Station data:', formData);
  };

  return (
    <div className="lg:pl-72 sm:ml-0 px-0 sm:px-0">
      <Titlebar title="Add Station" />
      
      <div className="mx-auto max-w-full px-4 py-8 sm:px-6 lg:px-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="bg-white shadow-sm sm:rounded-xl">
            <div className="px-4 py-6 sm:p-8">
              <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                
                {/* Station Name */}
                <div className="sm:col-span-2 lg:col-span-2">
                  <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                    Station Name
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Call Sign */}
                <div className="sm:col-span-1 lg:col-span-1">
                  <label htmlFor="call" className="block text-sm font-medium leading-6 text-gray-900">
                    Call Sign
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="call"
                      id="call"
                      value={formData.call}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Band */}
                <div className="sm:col-span-1 lg:col-span-1">
                  <label htmlFor="band" className="block text-sm font-medium leading-6 text-gray-900">
                    Band
                  </label>
                  <div className="mt-2">
                    <select
                      id="band"
                      name="band"
                      value={formData.band}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    >
                      <option value="FM">FM</option>
                      <option value="AM">AM</option>
                    </select>
                  </div>
                </div>

                {/* Frequency */}
                <div className="sm:col-span-1 lg:col-span-1">
                  <label htmlFor="frequency" className="block text-sm font-medium leading-6 text-gray-900">
                    Frequency
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="frequency"
                      id="frequency"
                      value={formData.frequency}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* City */}
                <div className="sm:col-span-1 lg:col-span-1">
                  <label htmlFor="city" className="block text-sm font-medium leading-6 text-gray-900">
                    City
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="city"
                      id="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* State */}
                <div className="sm:col-span-1 lg:col-span-1">
                  <label htmlFor="state" className="block text-sm font-medium leading-6 text-gray-900">
                    State
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="state"
                      id="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      maxLength="2"
                    />
                  </div>
                </div>

                {/* Country */}
                <div className="sm:col-span-1 lg:col-span-1">
                  <label htmlFor="country" className="block text-sm font-medium leading-6 text-gray-900">
                    Country
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="country"
                      id="country"
                      value={formData.country}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      maxLength="2"
                    />
                  </div>
                </div>

                {/* Website */}
                <div className="sm:col-span-2 lg:col-span-2">
                  <label htmlFor="website" className="block text-sm font-medium leading-6 text-gray-900">
                    Website
                  </label>
                  <div className="mt-2">
                    <input
                      type="url"
                      name="website"
                      id="website"
                      value={formData.website}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Logo URL */}
                <div className="sm:col-span-2 lg:col-span-2">
                  <label htmlFor="logo_url" className="block text-sm font-medium leading-6 text-gray-900">
                    Logo URL
                  </label>
                  <div className="mt-2">
                    <input
                      type="url"
                      name="logo_url"
                      id="logo_url"
                      value={formData.logo_url}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Description */}
                <div className="col-span-full">
                  <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                    Description
                  </label>
                  <div className="mt-2">
                    <textarea
                      id="description"
                      name="description"
                      rows={3}
                      value={formData.description}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Stream Provider */}
                <div className="sm:col-span-2 lg:col-span-2">
                  <label htmlFor="stream_provider" className="block text-sm font-medium leading-6 text-gray-900">
                    Stream Provider
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="stream_provider"
                      id="stream_provider"
                      value={formData.stream_provider}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Stream URL */}
                <div className="sm:col-span-2 lg:col-span-2">
                  <label htmlFor="stream_url" className="block text-sm font-medium leading-6 text-gray-900">
                    Stream URL
                  </label>
                  <div className="mt-2">
                    <input
                      type="url"
                      name="stream_url"
                      id="stream_url"
                      value={formData.stream_url}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Stream Acquisition URL */}
                <div className="col-span-full">
                  <label htmlFor="stream_acquisition_url" className="block text-sm font-medium leading-6 text-gray-900">
                    Stream Acquisition URL
                  </label>
                  <div className="mt-2">
                    <input
                      type="url"
                      name="stream_acquisition_url"
                      id="stream_acquisition_url"
                      value={formData.stream_acquisition_url}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Parent Company */}
                <div className="sm:col-span-2 lg:col-span-2">
                  <label htmlFor="parent_company" className="block text-sm font-medium leading-6 text-gray-900">
                    Parent Company
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="parent_company"
                      id="parent_company"
                      value={formData.parent_company}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* Parent Company Website */}
                <div className="sm:col-span-2 lg:col-span-2">
                  <label htmlFor="parent_company_website" className="block text-sm font-medium leading-6 text-gray-900">
                    Parent Company Website
                  </label>
                  <div className="mt-2">
                    <input
                      type="url"
                      name="parent_company_website"
                      id="parent_company_website"
                      value={formData.parent_company_website}
                      onChange={handleInputChange}
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
              <button
                type="button"
                className="text-sm font-semibold leading-6 text-gray-900"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Save Station
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StationAddForm;